import { Toast } from '@base-ui-components/react/toast'
import type { StreamEvent } from '@langchain/core/tracers/log_stream'

export const getLanggraphEventHandler = (
  event: StreamEvent,
  onChatStream?: (event: StreamEvent) => void
) => {
  let clientSideHandler
  switch (event.name) {
    case 'LangGraph':
      switch (event.event) {
        case 'on_chain_start':
          if (!event?.metadata?.langgraph_node) {
            clientSideHandler = (
              toastManager: Toast.useToastManager.ReturnValue
            ) => {
              toastManager.add({
                title: 'Run has started...'
              })
            }
          }
          break
        case 'on_chain_end':
          clientSideHandler = (
            toastManager: Toast.useToastManager.ReturnValue
          ) => {
            toastManager.add({
              title: 'Run has completed.'
            })
          }
      }
      break
    case 'ChatOllama':
      switch (event.event) {
        case 'on_chat_model_stream':
          clientSideHandler = () => {
            onChatStream?.(event)
          }
      }
  }
  return { clientSideHandler }
}
